export class ShowFile {
    show: boolean =  false; 
    url: string = "";
    display: string = "none";
    constructor(){
        
    }
}


// WEBPACK FOOTER //
// ./src/app/components/rtb/info/class/show-file.ts